import { useSetToastsState } from "../../app/hooks/useSetToastsState";
import { useToastsValue } from "../../app/hooks/useToastsValue";
import { useDismissToast } from "../../common/hooks/useDismissToast";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { setTimeoutMockable } from "../../common/miscellaneous/setTimeout";
import { Toast } from "../../common/miscellaneous/toastsAtom";
import { OrderErrorKey } from "../../common/miscellaneous/translationFromErrorCode";

export const toastFullDuration = 10000;

export function useAppendToast() {
  const toastsValue = useToastsValue();
  const setToasts = useSetToastsState();
  const dismissToast = useDismissToast();

  /**
   * @param id An identifier that can be used to later modify or dismiss the individual toast.
   * @returns The identifier that can be used to later modify or dismiss the individual toast.
   */
  return function appendToast(
    toast: Omit<Toast, "joiningKey">,
    joiningKey: DataTestids | OrderErrorKey
  ) {
    if (
      toast.message === "" ||
      // allow concurrent success indications
      (toast.tag !== "success" &&
        toastsValue?.map((item) => item.message).includes(toast.message))
    ) {
      return undefined;
    } else {
      setToasts((items) => [
        ...(items === null ? [] : items),
        { joiningKey, ...toast },
      ]);

      if (toast.tag === "success") {
        setTimeoutMockable(function () {
          dismissToast(joiningKey);
        }, toastFullDuration);
        return joiningKey;
      } else {
        return joiningKey;
      }
    }
  };
}
